module.exports = __webpack_public_path__ + "img/snkrhud-logo-white.fb9acd95.png";